import AssigneeIcon from "../images/filterIcons/assignee.svg";
import DROPDOWN_CF_ICON from "../images/filterIcons/cf_dropdown.svg";
import StatusIcon from "../images/filterIcons/status.svg";

export const FILTER_KEYS = {
  ASSIGNEE_FILTER: "assigned_to",
  STATUS_FILTER: "status",
  TAGS_FILTER: "tags",
  WITHOUT_TAGS_FILTER: "without_tags",
};

export const CUSTOM_FIELD_FILTER_KEY = "custom_field";

export const FILTER_LABEL_MAP = {
  [FILTER_KEYS.ASSIGNEE_FILTER]: "Assignee",
  [FILTER_KEYS.STATUS_FILTER]: "Status",
  [FILTER_KEYS.TAGS_FILTER]: "Contain",
  [FILTER_KEYS.WITHOUT_TAGS_FILTER]: "Do not contain",
};

export const FILTER_ICON_MAP = {
  [FILTER_KEYS.ASSIGNEE_FILTER]: AssigneeIcon,
  [FILTER_KEYS.STATUS_FILTER]: StatusIcon,
  [CUSTOM_FIELD_FILTER_KEY]: DROPDOWN_CF_ICON,
};

export const STATUS_KEYS = {
  STATUS_OPEN: "open",
  STATUS_PENDING: "pending",
  STATUS_CLOSE: "close",
  STATUS_SM_REMOVE: "sm_remove",
};

export const STATUS_LABEL_MAP = {
  [STATUS_KEYS.STATUS_OPEN]: "Open",
  [STATUS_KEYS.STATUS_PENDING]: "Pending",
  [STATUS_KEYS.STATUS_CLOSE]: "Closed",
  [STATUS_KEYS.STATUS_SM_REMOVE]: "Removed from mailbox",
};

export const OPERATOR_KEYS = {
  ANY: "any",
  ALL: "all",
};

export const OPERATOR_LABEL_MAP = {
  [OPERATOR_KEYS.ANY]: "Any",
  [OPERATOR_KEYS.ALL]: "All",
};

export const OPERATOR_RADIO_LABEL_MAP = {
  [OPERATOR_KEYS.ANY]: "Any selected tag",
  [OPERATOR_KEYS.ALL]: "All selected tags",
};
